import React from "react";
import Head from "next/head";

import AboutMain from "@/components/about/about-main";

import SeoMetaData from "@/components/utils/seo-metadata";
import seoData from "@/data/seo/page-data.json";

const About = () => {
  return (
    <>
      <Head>
        <title>{seoData.ABOUT_US.title}</title>
        <SeoMetaData data={seoData.ABOUT_US} />
      </Head>
      <AboutMain />
    </>
  );
};

export default About;
